import Axios from "axios";
import { host  ,Gatwayhost} from "../../Config";

const role_axios = Axios.create({
  baseURL: Gatwayhost + "/main-service",
});

role_axios.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    config.headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

role_axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

export default role_axios;
